/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import * as React from 'react';
import './index.scss';
import classNames from 'classnames';
import BetterScroll from '@better-scroll/core';
import Pullup from '@better-scroll/pull-up';
import Pulldown from '@better-scroll/pull-down';
import Serve from './../../../../serve';
import { HYToast, HYRouter } from '@hy-hybrid/kiwi-js-sdk';
import { Loading } from '@huyafed/comp';
import {
  regFenToYuan,
  reportFuc,
  formatDate2,
  getURLParam
} from './../../../../utils';
import PopSuccessNew from '../PopSuccessItem';
const { openUrl } = HYRouter;
const { showToast } = HYToast;
BetterScroll.use(Pullup);
BetterScroll.use(Pulldown);
interface PropsInterface {
  status: boolean;
  set: any;
  inved: number;
  isDebug: boolean;
  // setShowPop: any
}
const { useEffect, useRef, useState } = React;
let firstLoad = true;
const isHdtd = getURLParam('hdtd') !== null;
const Detail: React.FC<PropsInterface> = (props) => {
  const scrollDom: React.MutableRefObject<any> = useRef(null);
  const bs: React.MutableRefObject<any> = useRef(null);
  const canLoadMore: React.MutableRefObject<boolean> = useRef(true);
  const [load, setLoad] = useState(true);
  const [data, setData] = useState<any>([]);
  const showData: React.MutableRefObject<any> = useRef([]);
  const [lCash, setlCash] = useState(0);
  const [lValue, setlValue] = useState(0);
  const [balance, setBalance] = useState(0);
  const [iInvCount, setiInvCount] = useState(0);
  const totalList: React.MutableRefObject<number> = useRef(0);
  const loadCount: React.MutableRefObject<number> = useRef(20);
  const [loadCounts, setLoadCounts] = useState(0);
  const [tabIdx, setIndex] = useState(0);
  const tabIndex: React.MutableRefObject<number> = useRef(0);
  const [showSuccess, setShowSuccess] = useState(false);
  const getFriendInvitationDetail = (idx) => {
    Serve.getFriendInvitationDetail(0, 20, idx).then((rsp: any) => {
      console.log('getFriendInvitationDetail-', rsp);
      if (rsp.code === 0 && rsp.data.iReturnCode === 0) {
        setData(rsp.data.vDetail.value.slice(0, 20));
        console.log('收益数据: ', rsp.data.vDetail.value.slice(0, 20));
        showData.current = rsp.data.vDetail.value.slice(0, 20);
        setlCash(rsp.data.tTotal.lCash);
        setlValue(rsp.data.tTotal.lValue);
        setiInvCount(rsp.data.iInvCount);
        totalList.current = rsp.data.iTotal;
        setLoadCounts(loadCount.current);
        setLoad(false);
      } else {
        showToast({
          message: '网络繁忙!'
        });
        setLoad(false);
      }
    });
  };
  const [popData, setpopData] = useState({
    lCash: 0,
    lValue: 0,
    lPoint: 0,
    lExp: 0,
    vGift: {}
  });
  const hideSuccessPop = () => {
    setpopData({
      lCash: 0,
      lValue: 0,
      lPoint: 0,
      lExp: 0,
      vGift: {}
    });
    setShowSuccess(false);
  };
  useEffect(() => {
    if (!props.status) {
      loadCount.current = 20;
      return;
    }
    reportFuc(
      'sys/pageview/ldx/profitdetail',
      '系统/页面展示/老带新/收益明细浮层曝光',
      {}
    );
  }, [props.status]);
  useEffect(() => {
    if (!props.status) {
      setlCash(0);
      setlValue(0);
      setiInvCount(0);
      setData([]);
      totalList.current = 0;
      showData.current = [];
      if (bs.current) bs.current.scrollTo(0, 0);
      return;
    }
    setLoad(true);
    getFriendInvitationDetail([0, 2, 1, 3][tabIdx]);
    if (bs.current) bs.current.scrollTo(0, 0);
    Serve.checkBalance().then((rsp) => {
      if (rsp.code === 0) {
        setBalance(rsp.data.lBalance + rsp.data.lFrozenBalance);
      } else {
        showToast({
          message: rsp.errorMessage
        });
      }
    });
  }, [props.status, tabIdx]);
  const pullUpHandler = async (Bs, old = showData.current) => {
    if (!canLoadMore.current || loadCount.current >= totalList.current) {
      return Bs.finishPullUp();
    }
    canLoadMore.current = false;
    const newData: any = await Serve.getFriendInvitationDetail(
      loadCount.current,
      20,
      tabIndex.current
    );
    loadCount.current = loadCount.current + 20;
    setLoadCounts(loadCount.current);
    setData([...old, ...newData.data.vDetail.value]);
    showData.current = [...old, ...newData.data.vDetail.value];
    canLoadMore.current = true;
    Bs.finishPullUp();
  };
  const finishPullDown = async (Bs) => {
    setLoad(true);
    setData([]);
    showData.current = [];
    loadCount.current = 20;
    setLoadCounts(loadCount.current);
    Bs.refresh();
    await new Promise((reosolve) => {
      setTimeout(() => {
        reosolve(true);
      }, 500);
    });
    const newData: any = await Serve.getFriendInvitationDetail(
      0,
      20,
      [0, 2, 1, 3][tabIndex.current]
    );
    setData([...newData.data.vDetail.value]);
    showData.current = [...newData.data.vDetail.value];
    setLoad(false);
    Bs.finishPullDown();
  };
  useEffect(() => {
    if (!bs.current) {
      bs.current = new BetterScroll(scrollDom.current, {
        probeType: 3,
        click: true,
        pullUpLoad: true,
        pullDownRefresh: true
      });
    }
    const Bs = bs.current;
    Bs.on('touchEnd', (pos) => {
      if (pos.y >= 0) {
        if (pos.y > 70) {
          finishPullDown(Bs);
        } else {
          Bs.finishPullDown();
        }
      } else {
        if (pos.y < Bs.maxScrollY - 70) {
          pullUpHandler(Bs);
        }
      }
    });
    bs.current = Bs;
    return () => {
      Bs.destroy && Bs.destroy();
      bs.current = null;
    };
  }, []);
  useEffect(() => {
    const Bs = bs.current;
    if (data.length !== 0 && Bs && !load) {
      Bs.refresh();
    }
  }, [data, load]);
  return (
    <>
      {showSuccess && (
        <PopSuccessNew tTotal={popData} hidePop={hideSuccessPop} />
      )}
      {props.status && (
        <div
          className="shadow"
          onClick={() => {
            firstLoad = false;
            props.set(false);
          }}
        />
      )}
      <div
        className={classNames('detail-new', {
          out: !isHdtd && !firstLoad && !props.status,
          in: !isHdtd && props.status,
          wholein: isHdtd && props.status,
          wholeout: isHdtd && !firstLoad && !props.status,
          whole: isHdtd
        })}
      >
        <i className={classNames('detail-top')} />
        {isHdtd ? (
          <i
            className="detail-back"
            onClick={() => {
              firstLoad = false;
              props.set(false);
            }}
          />
        ) : (
          <i
            className="detail-close"
            onClick={() => {
              firstLoad = false;
              props.set(false);
            }}
          />
        )}
        <p className="detail-desc">所有奖励发放需最长24小时审核，敬请谅解</p>
        <ul className="detail-info">
          <li>
            <h3>
              <i className="friend" />
              已邀朋友
            </h3>
            <div className="money-item">
              <div className="money">
                <h4>{iInvCount}</h4>
                <h5>位</h5>
              </div>
            </div>
          </li>
          <li>
            <h3>
              <i className="total" />
              累计收益
            </h3>
            <div className="money-item">
              <div className="money">
                <h4>{regFenToYuan(lValue + lCash)}</h4>
                <h5>元</h5>
              </div>
            </div>
          </li>
          <li
            onClick={() => {
              reportFuc(
                'usr/click/ldx/profitdetail/minorencash',
                '用户/点击/老带新/收益明细浮层/收益明细提现按钮点击',
                {}
              );
              // if (props.inved === 0) {
              //   props.set(false)
              //   props.setShowPop(true)
              //   return
              // }

              openUrl({
                url: `https://${
                  props.isDebug ? 'test-hd' : 'hd'
                }.huya.com/h5/task_center/index.html#/cash-out`
              });
            }}
          >
            <h3>
              <i className="cash" />
              现金
              <div className="arrow">
                提现
                <i className="icon" />
              </div>
            </h3>
            <div className="money-item">
              <div className="money">
                <h4>{regFenToYuan(balance)}</h4>
                <h5>元</h5>
              </div>
            </div>
          </li>
        </ul>
        <ul className="detail-tab">
          {['全部', '新', '回归', '老'].map((item, idx) => (
            <li
              key={item}
              className={classNames('tab-item', {
                on: idx === tabIndex.current
              })}
              onClick={() => {
                tabIndex.current = idx;
                setIndex(idx);
                reportFuc(
                  'usr/click/ldx/profitdetail_tab',
                  '用户/点击/老带新/收益明细tab',
                  { tab_name: ['whole', 'back', 'new', 'normal'][idx] }
                );
              }}
            >
              {item}朋友
            </li>
          ))}
        </ul>
        <div className="detail-wrapper" ref={scrollDom}>
          <ul className="detail-list">
            {load ? (
              <Loading diameter={10} type={1} color={'#B5734C'} />
            ) : (
              <>
                <p className="reload">重新加载...</p>
                {data.length === 0 ? (
                  <div className="none"></div>
                ) : (
                  <>
                    {data.map((item, idx) => (
                      <li
                        key={idx}
                        className={classNames({
                          pending:
                            item.iStatus === 0 && item.tAward.iTaskStu === 0,
                          pass:
                            item.iStatus === 1 && item.tAward.iTaskStu === 0,
                          fail: item.iStatus === 2 && item.tAward.iTaskStu === 0
                        })}
                        onClick={() => {
                          const { tAward } = item;
                          const { lCash, lValue, lPoint, vGift, lExp } = tAward;
                          setpopData({
                            lCash,
                            lValue,
                            lPoint,
                            vGift,
                            lExp
                          });
                          setShowSuccess(true);
                        }}
                      >
                        <div
                          className={classNames('detail-item-cover', {
                            last: idx === data.length - 1
                          })}
                        >
                          <div className="list-info">
                            <div className="info-avatar">
                              <img
                                alt={item.sNickName}
                                src={item.sAvatarUrl}
                                onError={(event: any): void => {
                                  event.target.onerror = null;
                                  event.target.src =
                                    'https://diy-assets.msstatic.com/Activity-Public-Image/default-2.png';
                                }}
                              />
                              {item.iInvedType !== 0 && (
                                <i
                                  className={classNames('label', {
                                    new: item.iInvedType === 2,
                                    old: item.iInvedType === 3,
                                    back: item.iInvedType === 1
                                  })}
                                />
                              )}
                            </div>
                            <div className="info-detail">
                              <div className="name">{item.sNickName}</div>
                              <div className="info-time">
                                <p className="time">
                                  {formatDate2(
                                    (item.tAward.lAwardTime
                                      ? item.tAward.lAwardTime
                                      : item.lInvedTime) * 1000
                                  )}{' '}
                                  {item.tAward.iTaskStu === 0
                                    ? item.tAward.sReason
                                    : '完成绑定（0点失效）'}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="list-money">
                            {item.tAward.iTaskStu === 0 ? (
                              <>
                                {' '}
                                {item.tAward.lCash !== 0 && (
                                  <p>
                                    <span className="add">+</span>
                                    <span className="money">
                                      {(item.tAward.lCash / 100).toFixed(2)}
                                    </span>
                                    元现金
                                  </p>
                                )}
                                {item.tAward.lValue !== 0 && (
                                  <p className="libao">
                                    <span className="add">+</span>
                                    <span className="money">
                                      {(item.tAward.lValue / 100).toFixed(2)}
                                    </span>
                                    元礼包
                                  </p>
                                )}
                              </>
                            ) : (
                              <div className="m-other">
                                <p>好友看直播后</p>
                                <p>才有奖励哦</p>
                              </div>
                            )}
                          </div>
                        </div>
                        {item.tAward.iTaskStu === 0 && <i className="icon"></i>}
                      </li>
                    ))}
                  </>
                )}
                {data.length >= 20 && (
                  <p className="loadmore">
                    {loadCounts >= totalList.current
                      ? '暂无更多'
                      : '加载更多...'}
                  </p>
                )}
              </>
            )}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Detail;
